import * as XLSX from "xlsx";

const pad = (value: number): string => String(value).padStart(2, "0");

const buildTimestamp = (now: Date): string =>
  `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(
    now.getMinutes(),
  )}${pad(now.getSeconds())}`;

export const exportRowsToXlsx = (
  headers: string[],
  rows: string[][],
  sheetName: string,
  fileNameBase: string,
): void => {
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, `${fileNameBase}_${buildTimestamp(new Date())}.xlsx`);
};
